import React from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import { FieldsetMUI } from 'components/StyledElements'
import { Stack } from '@mui/material'
import ParameterWithSuperMultiAutocomplete from '../inputs/ParameterWithSuperMultiAutocomplete'
import ParameterWithSwitch from '../inputs/ParameterWithSwitch'
import { SeeOtherIconTooltip } from '../SeeIconTooltip'
import { usedUrl } from 'conf/basepath'
import LocationCityRoundedIcon from '@mui/icons-material/LocationCityRounded'
import { shallowEqual, useSelector } from 'react-redux'

const ProductionUnitParameters = ({
    defaultProps,
}) => {
    const {
        qualityThresholds,
    } = useSelector(store => ({
        qualityThresholds: store.QualityReducer.thresholds,
    }), shallowEqual)

    return (
        <FieldsetMUI
            title={(
                <Stack direction='row' alignItems='center' gap={0.5} sx={{ padding: '0 0.5rem' }}>
                    <LocationCityRoundedIcon />
                    {i18n.productionUnitName}
                </Stack>
            )}
        >
            <Stack spacing={1.25}>
                <ParameterWithSuperMultiAutocomplete
                    {...defaultProps}
                    parameter='PROD_REFERENCE_THRESHOLD'
                    options={qualityThresholds}
                    title={i18n.referenceThresholds}
                    keyLabel='name'
                    iconTooltip={
                        <SeeOtherIconTooltip
                            title={i18n.seeQualityThresholds}
                            link={`${usedUrl}#/quality/qualityOptions/threshold`}
                        />
                    }
                    multiple
                    limit={1}
                />
                <ParameterWithSwitch
                    {...defaultProps}
                    parameter='OBSERVATOIRE_PERIODES_DE_RETOUR'
                    title={i18n.returnPeriodsDisplay}
                />
                <ParameterWithSwitch
                    {...defaultProps}
                    parameter='OBSERVATOIRE_STRESS_HYDRIQUE'
                    title={i18n.waterStressDisplay}
                />
            </Stack>
        </FieldsetMUI>
    )
}

ProductionUnitParameters.propTypes = {
    defaultProps: PropTypes.shape({}),
}

export default ProductionUnitParameters
